import type { PropsWithChildren } from "react";
import { Typography } from "@circle-react-uikit/Typography";

export const TabTitle = ({ children }: PropsWithChildren<unknown>) => (
  <Typography.TitleXl truncate weight="font-bold">
    {children}
  </Typography.TitleXl>
);
